import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import Pagination from '../common/Pagination';
import Button from '../common/Button';

import {
  fetchDeleteFeedSettings,
  fetchGetFeedSettings,
  fetchRefreshFeed,
} from '../../actions/settings';
import { showModal } from '../../actions/modal';

import { parseError } from '../../helpers';

import { FEEDS_COUNT_ON_PAGE } from '../../config';

const Wrapper = styled('div')`
  .item-remove {
    display: none;
    cursor: pointer;
    padding: 10px 0;
  }

  .item-edit {
    cursor: pointer;
  }

  .edit-icon {
    margin-left: 5px;
    visibility: hidden;
  }

  .feed-row:hover {
    .item-remove {
      display: block;
    }

    .edit-icon {
      visibility: visible;
    }
  }
`;

const FeedsBlock = (props) => {
  const dispatch = useDispatch();
  const [feeds, setFeeds] = useState([]);
  const [feedsTotal, setFeedssTotal] = useState(0);
  const [feedsCurrentPage, setFeedsCurrentPage] = useState(0);

  const fetchFeedsList = (page) => {
    return dispatch(
      fetchGetFeedSettings({
        page,
        size: FEEDS_COUNT_ON_PAGE,
      }),
    ).then(({ settings, recordsTotal }) => {
      setFeeds(settings);
      setFeedssTotal(recordsTotal);
      setFeedsCurrentPage(page);
    });
  };

  useEffect(() => {
    fetchFeedsList(0);
  }, []);

  const handleUpdateFeed = (id) => {
    fetchFeedsList(0);

    //После любого редактирования API возвращает отредактированного контрагента в конце списка. Поэтому перелистываем список на последний лист пагинации.
    /*fetchCounteragentsList(Math.ceil(countragentsTotal/COUNTRAGENTS_COUNT_ON_PAGE) - 1);
        setCountragentsCurrentPage(Math.ceil(countragentsTotal/COUNTRAGENTS_COUNT_ON_PAGE) - 1);*/
  };

  const handleEditFeed = (feed) => {
    dispatch(
      showModal('EditFeedSettings', {
        feed,
        handleUpdateFeed,
      }),
    );
  };

  const handleDelete = (feed) => {
    //ToDo удаление не работает
    dispatch(
      showModal('Confirm', {
        body: `Подтвердите удаление фида "${feed.name}"`,

        handleConfirm: async () => {
          await dispatch(fetchDeleteFeedSettings(feed.id)).catch((err) => {
            toast.error(parseError(err));
            throw err;
          });

          await fetchFeedsList(feedsCurrentPage);
          toast.info('Фид успешно удален');
        },

        confirmBtnTitle: 'Удалить',
      }),
    );
  };

  const handleRefresh = async (feed) => {
    await dispatch(fetchRefreshFeed(feed.id)).catch((err) => {
      toast.error(parseError(err));
      throw err;
    });

    await fetchFeedsList(feedsCurrentPage);
    toast.info('Файл успешно обновлен');
  };

  return (
    <Fragment>
      <div className="border-bottom">
        <h4 className="header-title">Фиды для Яндекс.Маркета</h4>
      </div>

      <Wrapper style={{ paddingTop: '16px' }} className="feeds-wrapper">
        <div className="row" style={{ marginBottom: '16px' }}>
          <div className="col-lg-6"></div>
          <div className="col-lg-6">
            <div className="text-lg-right">
              <Button
                classType="btn-danger"
                type="button"
                icon="fe-plus"
                text="Новый фид"
                onClick={() => handleEditFeed(null)}
              />
            </div>
          </div>
        </div>

        <div className="fixed-table-container">
          <div className="table-responsive">
            <table className="table table-centered table-hover">
              <thead className="thead-light">
                <tr>
                  <th>Наименование</th>
                  <th>Ссылка на YML-файл для выгрузки</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {feeds
                  ? feeds.map((feed) => (
                      <tr key={feed.id} className="feed-row">
                        <td>
                          <div className="item-edit" onClick={() => handleEditFeed(feed)}>
                            {feed.name}
                            <i className="fe-edit-2 edit-icon" />
                          </div>
                        </td>
                        <td>
                          <a href={feed.cloudUrl}>{feed.cloudUrl}</a>
                        </td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            type="button"
                            onClick={() => handleRefresh(feed)}
                          >
                            Обновить файл
                          </button>
                        </td>
                        <td style={{ width: '45px', height: '70px' }}>
                          <div className="item-remove" onClick={() => handleDelete(feed)}>
                            <i className="fe-trash-2" />
                          </div>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination
          total={feedsTotal}
          currentPage={feedsCurrentPage}
          onPageSelect={fetchFeedsList}
        />
      </Wrapper>
    </Fragment>
  );
};

export default FeedsBlock;
